import Partners from './Partners';
import { usePartners } from '../../hooks/usePartners';

/**
 * Smart container component that fetches partner data
 * and renders the Partners component.
 */
const PartnersContainer = () => {
  const { data: partners = [] } = usePartners();
  const logos = partners.map(p => p.logoUrl);

  if (logos.length === 0) return null;
  return <Partners logos={logos} />;
};

export default PartnersContainer;
